import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import ResetPasswordHandler from "./components/user-management/ResetPasswordHandler";
import WestSide from "./components/categories/WestSide";
import CategoryLayout from "./components/CategoryLayout";
import WomensWear from "./components/categories/WomensWear";
import MensWear from './components/categories/MensWear';
import Bags from './components/categories/Bags';
import Watches from './components/categories/Watches';
import Footwear from './components/categories/Footwear';
import Kids from './components/categories/Kids';
import Jewellery from './components/categories/Jewellery';
import Beauty from './components/categories/Beauty';
import HomesLiving from './components/categories/HomesLiving';
import Gadget from './components/categories/Gadget';
import ProductDetails from "./components/Details/ProductDetails";
import SearchResults from "./components/Search Results/SearchResults";
import CartScreen from "./components/Cart/CartScreen";
import WishlistScreen from "./components/Wishlist/WishlistScreen";
import { useEffect, useState } from "react";
import ResetPassword from "./components/user-management/resetPassword";
import Login from "./components/user-management/Login";
import CheckoutScreen from "./components/Checkout/CheckoutScreen";
import OrderConfirmation from "./components/OrderConfirmation/OrderConfirmation";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminDashboard from "./components/Admin/AdminDashboard";
import AddProducts from "./components/Add Products/AddProducts";
import CategoryPage from "./pages/CategoryPage";
import BrandPage from "./pages/BrandPage";
import AddressSelection from "./components/AddressSelection/AddressSelection";
import PaymentScreen from "./components/PaymentScreen/PaymentScreen";
import TrackOrder from "./components/TrackOrder/TrackOrder";
import AdminOrderDetails from "./components/Admin/AdminOrderDetails";
import MyAccount from "./components/MyAccount";

function App() {

  const [showResetPassword, setShowResetPassword] = useState(false);
  const [showLogin, setShowLogin] = useState(false);

  

  useEffect(() => {
    const handleShowResetPassword = (e) => {
      setShowResetPassword(true);
    }

    window.addEventListener('showResetPassword', handleShowResetPassword);

    return () => {
      window.removeEventListener('showResetPassword', handleShowResetPassword);
    }
  }, []);


  return (
    <BrowserRouter>
      <Routes>
      <Route path='/'  element={
        <>
        <Home/>
        <ResetPassword
        show={showResetPassword}
        onClose={() => setShowResetPassword(false)}
        onSwitchToLogin={() => {
          setShowResetPassword(false);
          setShowLogin(true);
        }}/>
        <Login
        show={showLogin}
        onClose={() => setShowLogin(false)}/>
        </>
      }/>
        <Route path='/home' index element={<Home/>}/>
        {/* <Route path='/register'  element={<Register/>}/> */}
        <Route path="/reset-password/:id/:token" element={<ResetPasswordHandler/>}/>

        <Route path="/category" element={<CategoryLayout/>}>
          <Route path="womens-wear" element={<WomensWear/>}/>
          <Route path="west-side" element={<WestSide/>}/>
          <Route path="mens-wear" element={<MensWear/>}/>
          <Route path="bags" element={<Bags/>}/>
          <Route path="watches" element={<Watches/>}/>
          <Route path="footwear" element={<Footwear/>}/>
          <Route path="kids" element={<Kids/>}/>
          <Route path="jewellery" element={<Jewellery/>}/>
          <Route path="beauty" element={<Beauty/>}/>
          <Route path="homes-living" element={<HomesLiving/>}/>
          <Route path="gadget" element={<Gadget/>}/>
        </Route>
        
        <Route path="/product/:id" element={<ProductDetails/>}/>
        <Route path="/search" element={<SearchResults/>}/>
        <Route path="/cart" element={<CartScreen/>}/>
        <Route path="/wishlist" element={<WishlistScreen/>}/>
        <Route path="/checkout" element={<CheckoutScreen/>}/>
        <Route path="/order-confirmation" element={<OrderConfirmation/>}/>
        <Route path="/checkout/address" element={<AddressSelection/>}/>
        <Route path="/payment" element={<PaymentScreen/>}/>

        <Route path="/admin" element={
        <ProtectedRoute adminOnly>
            <AdminDashboard/>
        </ProtectedRoute>
        }/>

        <Route path="/admin/products/add" element={
          <ProtectedRoute adminOnly>
            <AddProducts />
          </ProtectedRoute>
        }/>

        <Route path="/category/:category" element={<CategoryPage/>}/>
        <Route path="/brand/:brand" element={<BrandPage/>}/>
        <Route path="/track-order" element={<TrackOrder/>}/>
        <Route path="/orders/:orderId" element={<AdminOrderDetails/>}/>
        <Route path="/my-account" element={<MyAccount/>}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
